<template>
    <!-- <div class="tab-info" v-if="Object.keys(values).length > 0"> -->
    <div class="tab-info">
        <h2 v-if="title"> {{ title }} </h2>
        <table>
        <tr v-for="(val, key) of formatted" :key="key">
            <td>
                <icon v-if="val.icon" :name="val.icon"> </icon>
                {{ key }} 
            </td>
            <td align="right"> {{ $t(val.value) }} </td>
        </tr>
        </table>
        <JCAgent v-if="months" :values="values" :months="months"/>
    </div>
</template>
<script>
import {formatObject} from '@/util/formatting.js';
import JCAgent from './JCAgent.vue';

export default {
    name: 'tabbed-infos',
    components: {JCAgent},
    props: {
        values: Object,
        title: String,
        months: Array,
    },
    computed: {
        formatted() { return formatObject(this.values, true); },
    }
}
</script>

<style lang="scss" scoped>
#map-wrapper > .tab-info {
    display: none;
}
div {
    margin: 0 auto;
    border-radius: 4px;
    h2, h3 { text-align: center; }
    h2 { margin:5px; }
    h3 { margin:0 0 5px 0; }
    table{
        margin: 0 auto;
        border-collapse: collapse;
        tr:not(:first-child) { 
            border-top:1px #ddd solid;
        }
    }
}
</style>
